// =============================================================================
// src/data/live-debug.ts — Logs opt-in para diferenciar live vs fallback.
// =============================================================================

type DebugDetails = Record<string, unknown>;

export function liveDebugEnabled(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    return (
      window.localStorage?.getItem('sentinel-debug') === '1'
      || new URLSearchParams(window.location.search).has('debugSentinel')
    );
  } catch {
    return false;
  }
}

export function debugLiveIntegration(
  scope: string,
  event: string,
  details: DebugDetails = {},
): void {
  if (!liveDebugEnabled()) return;
  console.info(`[${scope}] ${event}`, details);
}
